import { render, staticRenderFns } from "./Unauthorized.vue?vue&type=template&id=bdf1d830"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bdf1d830')) {
      api.createRecord('bdf1d830', component.options)
    } else {
      api.reload('bdf1d830', component.options)
    }
    module.hot.accept("./Unauthorized.vue?vue&type=template&id=bdf1d830", function () {
      api.rerender('bdf1d830', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/base/Unauthorized.vue"
export default component.exports